import { useQuery } from 'react-query';
import { JsonFilePath, fetchAndMergeConfigJsonFiles } from '../utils/fetchAndMergeJsonFiles';
// import { fetchAndMergeConfigJsonFiles, JsonFilePath } from '../utils/fetchAndMergeJsonFiles';

const useFetchJsonFile = <T>(jsonFilePath: JsonFilePath) => (
    useQuery(
        ['json-file-fetch', jsonFilePath.path, jsonFilePath.useConfigUrl],
        () => fetchAndMergeConfigJsonFiles<T>(jsonFilePath),
    )
);

export default useFetchJsonFile;
